import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { ConversationPlatform } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import { EmailInfo } from "@redotech/redo-support-settings-common/email-info";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import UserIcon from "@redotech/redo-web/icon-old/user.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";
import { containsImg } from "./step-rich-text-util";

export interface AssignToAgentState {
  message: string;
  messageHtml?: string;
  emailPromptMessage: string;
  emailPromptMessageHtml?: string;
  followUpMessage: string;
  followUpMessageHtml?: string;
  channel: ConversationPlatform;
  customTitle?: string;
  emailToSendAs?: EmailInfo;
}

export const ASSIGN_TO_AGENT = (
  Details: React.ComponentType<StepTypeDetailsProps<AssignToAgentState>>,
): StepType<AssignToAgentState, ModelStep.AssignToAgent> => ({
  Details: (props: StepTypeDetailsProps<AssignToAgentState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {
    message:
      "Please wait while I connect you with a customer support representative.",
    messageHtml: undefined,
    emailPromptMessage:
      "We will contact you by email as soon as possible! What is the best email address at which we can contact you?",
    emailPromptMessageHtml: undefined,
    followUpMessage:
      "Thank you! We will contact you at the email address you provided shortly.",
    followUpMessageHtml: undefined,
    channel: ConversationPlatform.REDO_CHAT,
    emailToSendAs: { email: "", name: "", integrationKind: "" },
  },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  title: STEP_TYPE_NAMES[ModelStep.ASSIGN_TO_AGENT],
  valid(state) {
    return (
      !!state.message &&
      !containsImg(state.messageHtml) &&
      !containsImg(state.emailPromptMessageHtml) &&
      !containsImg(state.followUpMessageHtml) &&
      (state.channel === ConversationPlatform.REDO_CHAT ||
        (state.channel === ConversationPlatform.EMAIL &&
          !!state.emailToSendAs?.email))
    );
  },
  fromModel(model) {
    return {
      customTitle: model.customTitle,
      message: model.message,
      messageHtml: model.messageHtml,
      emailPromptMessage: model.emailPromptMessage,
      emailPromptMessageHtml: model.emailPromptMessageHtml,
      followUpMessage: model.followUpMessage,
      followUpMessageHtml: model.followUpMessageHtml,
      channel: model.channel,
      emailToSendAs: model.emailToSendAs,
    };
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.ASSIGN_TO_AGENT,
      message: state.message,
      messageHtml: state.messageHtml,
      emailPromptMessage: state.emailPromptMessage,
      emailPromptMessageHtml: state.emailPromptMessageHtml,
      followUpMessage: state.followUpMessage,
      followUpMessageHtml: state.followUpMessageHtml,
      channel: state.channel,
      emailToSendAs: state.emailToSendAs,
    };
  },
  Icon: UserIcon,
});
